import { render, staticRenderFns } from "./reset-password.component.vue?vue&type=template&id=72eed121"
import script from "./reset-password.component.ts?vue&type=script&lang=ts&external"
export * from "./reset-password.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72eed121')) {
      api.createRecord('72eed121', component.options)
    } else {
      api.reload('72eed121', component.options)
    }
    module.hot.accept("./reset-password.component.vue?vue&type=template&id=72eed121", function () {
      api.rerender('72eed121', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/reset-password/reset-password.component.vue"
export default component.exports